<template>
    <div class="sec-cont">
        <Head :title="title"/>
        <div class="max-w-full bg-white rounded-md shadow overflow-hidden p-6">
            <span class="h2 font-bold mb-4">Ticket Type: {{ ticket.ticket_type }}</span>
            <div class="flex flex-wrap -mb-8 mt-4 -mr-6">
                <div class="pb-8 pr-6 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Subject: &nbsp;</div>
                        <div class="value">{{ ticket.subject }}
                        </div>
                    </div>
                </div>
                <div class="pb-8 pr-6 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Priority: &nbsp;</div>
                        <div class="value">{{ ticket.priority }}</div>
                    </div>
                </div>

                <div class="pb-8 pr-6 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Assigned: &nbsp;</div>
                        <div class="value">{{ usersNames(ticket.assigned_users) }}</div>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap -mb-8 mt-4 -mr-6">
                <div class="pb-8 pr-6 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Student Name: &nbsp;</div>
                        <div class="value">{{ ticket.student_name }}</div>
                    </div>
                </div>
                <div class="pb-8 pr-6 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Father Name: &nbsp;</div>
                        <div class="value">{{ ticket.father_name }}</div>
                    </div>
                </div>
            </div>

            <div class="flex flex-wrap -mb-8 mt-4 -mr-6">
                <div class="pb-8 pr-6 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Class: &nbsp;</div>
                        <div class="value">{{ ticket.education_level }}
                        </div>
                    </div>
                </div>
                <div class="pb-8 pr-6 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Section: &nbsp;</div>
                        <div class="value">{{ ticket.section }}
                        </div>
                    </div>
                </div>
                <div class="pb-8 pr-6 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Stream: &nbsp;</div>
                        <div class="value">{{ ticket.stream }}
                        </div>
                    </div>
                </div>

            </div>

            <div class="flex flex-wrap -mb-8 mt-4 -mr-6">
                <div class="pb-8 pr-6 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Contact Number: &nbsp;</div>
                        <div class="value">{{ ticket.contact_number }}</div>
                    </div>
                </div>

                <div class="pb-8 pr-6 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Email Address: &nbsp;</div>
                        <div class="value">{{ ticket.email_address }}</div>
                    </div>
                </div>
                <div class="pb-8 pr-6 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Department: &nbsp;</div>
                        <div class="value">{{ ticket.department }}</div>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap -mb-8 mt-4 -mr-6">

                <div class="pb-8 pr-6 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">CC: &nbsp;</div>
                        <div class="value">
                            {{ usersNames(ticket.cc_users) }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex flex-wrap -mb-8 mt-4 -mr-6">
                <div class="pb-8 pr-6 w-full lg:w-full">
                    <div class="info-row">
                        <div class="label">Description: &nbsp;</div>
                        <div class="value" v-html="ticket.description"></div>
                    </div>
                </div>
            </div>

            <hr class="mt-4">

            <div class="mt-4">
                <div v-for="(comment, comment_i) in ticket.support_comments">
                    <div class="chat-container" v-if="$page.props.auth.user.id !== comment.user.id">
                        <div class="chat-avatar mr-4">{{ getInitials(comment.user.name) }}</div>
                        <div class="chat-bubble">
                            <div class="chat-meta">
                                <div class="chat-name"> {{ comment.user.name }}</div>
                                <div class="chat-time">{{
                                        moment(comment.created_at).format('MMMM D, YYYY [at] h:mm a')
                                    }}
                                </div>
                            </div>
                            <div class="chat-content" v-html="comment.body">
                            </div>
                            <!--                        <div class="chat-footer">No file attachment</div>-->
                        </div>
                    </div>

                    <div class="chat-container chat-reply" v-if="$page.props.auth.user.id === comment.user.id">
                        <div class="chat-bubble">
                            <div class="chat-meta">
                                <div class="chat-name">{{ comment.user.name }}</div>
                                <div class="chat-time">{{
                                        moment(comment.created_at).format('MMMM D, YYYY [at] h:mm a')
                                    }}
                                </div>
                            </div>
                            <div class="chat-content" v-html="comment.body"></div>
                            <!--                        <div class="chat-footer">No file attachment</div>-->
                        </div>
                        <div class="chat-avatar ml-4">{{ getInitials(comment.user.name) }}</div>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <div>
                    <div v-if="!showCommentBox && ticket.status === 'open'"
                         class="mt-1 mb-4 cursor-pointer rounded-md border border-gray-300 hover:shadow"
                    >
                        <p @click="showCommentBox = true" class="px-3 py-2 text-sm ">
                            {{ __('Write a comment...') }}
                        </p>
                    </div>

                    <form v-if="showCommentBox" class="mt-1 mb-4 rounded-md border border-gray-300"
                          enctype="multipart/form-data"
                    >
                        <!--                                                <textarea v-model="new_comment.details" class="autosize p-3 comment-textarea block max-h-40 w-full resize-none rounded-md border-0 text-sm focus:ring-0" placeholder="Write a comment..." style="overflow: hidden; overflow-wrap: break-word;background:transparent">{{ new_comment.details || '' }}</textarea>-->
                        <quill-editor ref="editDescription" @ready="onEditorReady"
                                      class="task__description"
                                      v-model:content="new_comment.details" :options="editorOptions"
                                      contentType="html" theme="snow"
                        />

                        <div class="flex items-center px-3 pt-2 pb-3">
                            <div class="flex items-center">
                                <button
                                    @click="saveNewComment({body: new_comment.details, ticket_id: ticket.id, user_id: $page.props.auth.user.id}, ticket.support_comments)"
                                    type="button"
                                    class="inline-flex items-center rounded border border-gray-300 bg-indigo-600 text-white px-2.5 py-1.5 text-xs font-medium shadow-sm hover:bg-gray-50 hover:text-dark focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                >
                                    {{ __('Save') }}
                                </button>
                                <button @click="showCommentBox = false" type="button"
                                        class="inline-flex items-center rounded border border-transparent hover:border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-0 ltr:ml-1 rtl:mr-1"
                                >{{ __('Cancel') }}
                                </button>
                            </div>

                            <div class="ml-auto hidden flex">
                                <label class="cursor-pointer">
                                    <input
                                        accept="image/png, image/jpeg, image/gif,.doc,.docx,.pdf,.txt,.zip,.rar,.7zip,.mp4,video/*,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/vnd.ms-powerpoint,.webp,.tiff,.pptx,.mp3,.ai,.eps,.svg,.fig,.sketch,.jam"
                                        class="hidden" type="file"
                                        @change="uploadAttachment($event, true)"
                                    >
                                    <icon class="w-4 h-4" name="attachment"/>
                                </label>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!-- Submit Button -->
            <div class="flex items-center justify-center border-t border-gray-100 mt-4 float-right"  v-if="ticket.status === 'open'">

                <loading-button :loading="form.processing" class="btn-indigo mx-auto btn-red" type="submit"  @click="closeTicket()">{{
                        __('Close Ticket')
                    }}
                </loading-button>
            </div>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import AcademicQualifications from '@/Pages/Interview/AcademicQualifications'
import axios from 'axios'
import moment from 'moment'
import {QuillEditor} from '@vueup/vue-quill'
import Icon from '@/Shared/Icon'
import Loader from '@/Shared/Loader'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import 'moment-duration-format'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'

const FilePond = vueFilePond()
export default {

    components: {
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
        AcademicQualifications,
        QuillEditor,
        Icon,
        Loader, Datepicker, FilePond,
    },
    layout: Layout,
    props: {
        ticket: Object,
    },
    data() {
        return {
            showCommentBox: false,
            new_comment: {},
            quill: null,
            documentUploads: [
                {
                    selectedFile: null,
                    name: '',
                    uploaded: false,
                    preview: null,
                    fileItem: null,
                },
            ],
            uploadedDocuments: [],
            form: this.$inertia.form({
                errors: {},
                processing: false,
                editDescription: true,
            }),
            task: {},
            currentDate: new Date().toISOString().split('T')[0], // to set the max date
            editorOptions: {
                modules: {
                    toolbar: {
                        container: [
                            {'header': [1, 2, 3, 4, 5, 6, false]},
                            'bold', 'italic', 'underline', {'list': 'bullet'}, {'list': 'ordered'},
                            'align', 'clean',
                            'blockquote', 'code-block',
                            // 'image'
                        ],
                        // handlers: { 'image': this.imageButtonClickHandler }
                    },
                    // imageDrop: true,
                },
            },
        }
    },
    computed: {},
    methods: {
        getInitials(name) {
            // Split the name into words
            const words = name.split(' ');
            // Get the first letter of each word and concatenate them
            let initials = '';
            words.forEach(word => {
                if (word) {
                    initials += word.charAt(0).toUpperCase();
                }
            });
            return initials;
        },
        usersNames(users) {
            return users.map(user => user.name).join(', ')
        },

        async imageButtonClickHandler() {
            const input = document.createElement('input')
            input.setAttribute('type', 'file')
            input.click()
            input.onchange = async () => {
                const file = input.files[0]
                this.$refs.form.editDescription.focus()
            }

        },
        onEditorReady(editor) {
            editor.focus()
        },
        deleteAttachment(id, index) {
            if (this.task.cover && (this.task.cover.id === id)) {
                this.task.cover = null
            }
            axios.post(this.route('task.attachment.delete', id), {}).then((response) => {
                if (response.data) {
                    this.task.attachments.splice(index, 1)
                }
            })
        },
        async uploadAttachment(e, is_comment) {
            e.preventDefault()
            if (!e.target.files.length) {
                return
            }
            const file = e.target.files[0]
            if (this.task.is_demo && (file.size / 1024) / 1024 > 2) {
                alert('Uploading file size less than 2MB is not allowed in the demo mode!')
                return
            }
            const obj = await this.uploadFile(file)
            if (obj && obj.error) {
                alert('Please upload image, video, doc/pdf/text/ai/figma file formats only!')
            } else {
                this.task.attachments.push(obj)
                if (is_comment) {
                    const name = ['jpeg', 'png', 'gif', 'jpg', 'svg', 'webp', 'bmp'].includes(obj.name.split('.').pop()) ? `<img src="${obj.path}" alt="${obj.name}" />` : `${obj.name}`
                    const link = `<br/><a href="${obj.path}" target="_blank">${name}</a><br/>`
                    this.new_comment.details = this.new_comment.details || '' + link
                }
            }
        },
        async uploadFile(file) {
            let formData = new FormData()
            formData.append('file', file)
            const resp = await axios.post(this.route('task.attachment.add', this.task.id), formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            return resp.data
        },
        goToLink(link) {
            window.location.href = link
        },
        saveList(project_id, taskObject) {
            axios.post(this.route('task.update.list', project_id), taskObject).catch((error) => {
                console.log(error)
            })
        },
        searchUser(input) {
            return this.team_members.filter(tm => tm.user.name.toLowerCase().indexOf(input) > -1)
        },
        saveDetails() {
            if (this.task.description) {
                const desc = this.task.description
                this.saveTask({description: desc})
            }
        },
        async deleteTask() {
            await axios.post(this.route('task.delete', this.task.id), {})
            this.goToLink(this.route(this.view === 'table' ? 'projects.view.table' : 'projects.view.board', this.task.project_id))
        },
        saveTask(taskObject) {
            axios.post(this.route('task.update', this.task.id), taskObject).then((response) => {
                if (response.data) {
                    this.sendNotification('send.mail.task_update', response.data.id)
                }
            })
        },
        checklistDoneCount(checkList) {
            return checkList.filter(item => !!item.is_done).length
        },
        deleteComment(id, index, comments) {
            axios.post(this.route('comment.delete', id)).catch((error) => {
                console.log(error)
            })
            comments.splice(index, 1)
        },
        modifyCheckListSubmit(check_list, c_index, checklist) {
            if (!check_list.title) {
                this.deleteCheckList(check_list.id, c_index, checklist)
            } else {
                this.saveCheckList(check_list.id, {title: check_list.title})
            }
            check_list.modify = false
        },

        saveComment(id, commentObject) {
            axios.post(this.route('comment.update', id), {details: commentObject.details}).catch((error) => {
                console.log(error)
            })
        },
        saveNewCheckList(checkListObject, currentCheckList) {
            this.new_chek_list.title = ''
            this.editorKey += 1
            axios.post(this.route('check_list.new'), checkListObject).then((response) => {
                if (response.data) {
                    currentCheckList.push(response.data)
                }
            }).catch((error) => {
                console.log(error)
            })
        },
        saveNewComment(commentObject, currentComments) {
            this.new_comment.details = ''
            // commentObject.created_at = this.moment().format('YYYY/MM/DD HH:mm:ss')
            axios.post(this.route('supports.new'), commentObject).then((response) => {
                if (response.data) {
                    currentComments.push(response.data)
                    this.showCommentBox = false
                    //  this.sendNotification('send.mail.comment', response.data.id)
                }
            }).catch((error) => {
                console.log(error)
            })
        },
        closeTicket() {
            axios.post(this.route('ticket.close'), {"id":  this.ticket.id}).then((response) => {
                location.reload()
            }).catch((error) => {
                console.log(error);
            })
        },

        sendNotification(uri, id, user_id) {
            const data = {id}
            if (!!user_id) {
                data.user_id = user_id
            }
            axios.post(this.route(uri, data)).catch((error) => {
                console.log(error)
            })
        },
        async getTask(id) {
            const taskResponse = await axios.get(this.route('json.task.get', id))
            if (Object.keys(taskResponse.data).length) {
                this.task = await taskResponse.data
                this.counter.timer = this.task.timer || null
                if (this.counter.timer && (this.counter.timer.task_id === this.task.id)) {
                    this.startTimer()
                }
                this.loading = false
                await this.getOtherData()
            } else {
                alert('something went wrong')
            }
        },
        addMoreDocument() {
            // Add a new document upload field to the array
            this.documentUploads.push({
                selectedFile: null,
                name: '',
                uploaded: false,
                preview: null,
            })
        },
        fileAdded(fileItem, index) {
            // FilePond passes the file object directly as part of fileItem.file
            const file = fileItem.target.files[0]

            // Store the selected file for the specific document upload section
            this.documentUploads[index].selectedFile = file
            this.documentUploads[index].fileItem = fileItem

            // Generate a preview for image files or other supported types
            if (file) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.documentUploads[index].preview = e.target.result
                }
                reader.readAsDataURL(file) // Read the file and generate a preview
            }
        },
        async uploadDocument(index) {
            const file = this.documentUploads[index].selectedFile
            const documentName = this.documentUploads[index].name

            if (!file || !documentName) {
                alert('Please enter a document name and select a file before uploading.')
                return
            }

            await this.handlePhotoChange({file}, documentName)  // Pass the file object directly
        },
        async removeFile(fileName) {
            console.log('fileName is ' + fileName)
            const filePath = this.uploadedFiles[fileName]
            if (!filePath) return

            try {
                const formData = new FormData()
                formData.append('filePath', filePath)
                formData.append('user_id', this.applicant.id)

                await axios.post(this.route('document.remove'), formData)

                // Clear local state
                this.uploadedFiles[fileName] = null
                this.form[fileName] = null
                console.log('File removed successfully from server')
            } catch (error) {
                console.error('Error removing file from server:', error)
            }
        },
    },
    created() {
        this.moment = moment
    },

}
</script>
